const reg = {
    phoneReg: /^1[3456789]\d{9}$/,
    integer: (rule, value, callback) => {
        if (!value && value != 0) {
            return callback(new Error("请输入"));
        } else {
            if (!new RegExp(/^[1-9]\d*$/).test(value) && value !== 0) {
                callback(new Error("请输入正整数"));
            } else {
                callback();
            }
        }
    },
    realnumber: (rule, value, callback) => {
        if (!value && value != 0) {
            return callback(new Error("请输入"));
        } else {
            if (!new RegExp(/^(\d|[1-9]\d+)(\.\d{0,4})?$/).test(value)) {
                callback(new Error("请输入正实数,小数点后最多4位"));
            } else {
                callback();
            }
        }
    },
    phone: (rule, value, callback) => {
        if (!value) {
            return callback(new Error("手机号不能为空"));
        } else {
            if (!new RegExp(/^1[3456789]\d{9}$/).test(value)) {
                callback(new Error("请输入有效的手机号"));
            } else {
                callback();
            }
        }
    },
    telphone:(rule, value, callback) => {
        if (!value) {
            return callback(new Error("请输入11位手机号或座机号(xxxx-xxxxxxxx)"));
        } else {
            if (!new RegExp(/^1[3456789]\d{9}$/).test(value) && !new RegExp(/^0[0-9]{3}-[0-9]{8}$/).test(value)) {
                callback(new Error("请正确输入11位手机号或座机号(xxxx-xxxxxxxx)"));
            } else {
                callback();
            }
        }
    },
    mail: (rule, value, callback) => {
        if (!value) {
            return callback(new Error("邮箱不能为空"));
        } else {
            if (!new RegExp(/^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/).test(value)) {
                callback(new Error("请输入有效的邮箱"));
            } else {
                callback();
            }
        }
    },
}

export default reg